module.exports = __webpack_public_path__ + "img/wx_zsm.7db8be65.png";